import React, { useState, useEffect } from "react";

// const API_BASE_URL = "https://my-serverless-api.workers.dev/api"; // Replace with your Cloudflare Worker URL
// const API_BASE_URL = "https://my-serverless-api.workers.dev/api";
const API_BASE_URL =  "https://my-serverless-api.ideasonwork.workers.dev/api"
function App() {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");

  // Fetch tasks from the serverless API
  useEffect(() => {
    fetch(`${API_BASE_URL}/get-tasks`)
      .then((res) => res.json())
      .then((data) => setTasks(data.tasks))
      .catch((error) => console.error("Error fetching tasks:", error));
  }, []);

  // Add a new task using the API
  const addTask = async () => {
    if (newTask.trim() === "") return;

    const response = await fetch(`${API_BASE_URL}/add-task`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ task: newTask }),
    });

    if (response.ok) {
      setTasks([...tasks, newTask]);
      setNewTask("");
    } else {
      console.error("Error adding task");
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "20px", maxWidth: "400px", margin: "auto" }}>
      <h2>✅ Serverless To-Do List</h2>
      <input
        type="text"
        value={newTask}
        onChange={(e) => setNewTask(e.target.value)}
        placeholder="Enter a new task"
        style={{ padding: "8px", width: "80%" }}
      />
      <button onClick={addTask} style={{ marginLeft: "10px", padding: "8px" }}>Add</button>

      <ul style={{ listStyle: "none", padding: 0 }}>
        {tasks.map((task, index) => (
          <li key={index} style={{ padding: "5px", borderBottom: "1px solid #ccc" }}>
            {task}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;
